import { useCallback, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import InfiniteScroll from 'react-infinite-scroll-component'
import Table from 'src/features/base/components/Table'
import { ScrollMessage } from 'src/features/base/components/Table/Table.styles'
import { selectProductMovements, selectHasProductMovementsNextPage } from 'src/features/stock-management/StockManagementSeletor'
import { actions } from 'src/features/stock-management/StockManagementState'
import { Movement } from 'src/features/types'
import { mapMovementType } from 'src/utils/mappers/mapMovementType'
import { formatDate } from 'src/utils/formatDate'
import columns from './Table.columns'
import { useReactToPrint } from 'react-to-print'
import * as S from './Table.styles'
import { Link } from '@mui/material'

export default () => {
  const movements = useSelector(selectProductMovements)
  const hasNext = useSelector(selectHasProductMovementsNextPage)
  const dispatch = useDispatch()

  const [invoiceHtml, setInvoiceHtml] = useState<string>('')

  const handleNextPage = useCallback(() => {
    dispatch(actions.nextProductMovementsPage())
    dispatch(actions.getProductMovements())
  }, [dispatch])

  const printAreaRef = useRef(null)

  // eslint-disable-next-line react/no-danger
  const showInvoice = () => (<div style={{ pageBreakBefore: 'always' }} dangerouslySetInnerHTML={{ __html: invoiceHtml }} />)

  const printInvoice = useReactToPrint({
    content: () => printAreaRef.current,
    copyStyles: false,
  })

  const setInvoiceToPrint = (invoiceKey: string) => {
    setInvoiceHtml('')

    const onSuccess = (_invoiceHtml: string) => {
      setInvoiceHtml(_invoiceHtml)
      printInvoice()
    }

    dispatch(actions.getInvoiceToPrint({ invoiceKey, onSuccess }))
  }

  const invoiceHyperlink = (invoice: string) => (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      component='button'
      onClick={() => setInvoiceToPrint(invoice)}
      data-testid='invoice-hyperlink-test-id'
    >
      {invoice}
    </Link>
  )

  const receivementHyperlink = (receivementId: number) => (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      component='button'
      onClick={() => window.open(`/receivement/${receivementId}/details`, '_blank')}
      data-testid='receivement-hyperlink-test-id'
    >
      {receivementId}
    </Link>
  )

  const prepareMovements = (data: Movement[]) => data.map((m) => (
    {
      ...m,
      createdAt: formatDate(m.createdAt),
      type: mapMovementType(m.type),
      invoice: invoiceHyperlink(m.invoiceKey),
      receivement: receivementHyperlink(m.receivementId),
    }))

  return (
    <>
      <InfiniteScroll
        dataLength={movements.items.length}
        next={handleNextPage}
        hasMore={hasNext}
        loader={<ScrollMessage>Carregando mais dados</ScrollMessage>}
        endMessage={<ScrollMessage>Fim dos resultados</ScrollMessage>}
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <Table
          data={prepareMovements(movements.items)}
          columns={columns}
        />
      </InfiniteScroll>
      <S.PrintArea ref={printAreaRef}>
        {showInvoice()}
      </S.PrintArea>
    </>
  )
}
